import { render } from "./ofline.vue?vue&type=template&id=3423bbe8"
import script from "./ofline.vue?vue&type=script&lang=js"
export * from "./ofline.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__